









import { Condition } from '@ajax/vue/components/templates/item-list/condition/contactlens/model/condition'
import { Component, Prop, Vue } from 'vue-property-decorator'
import BaseButtonVue from './BaseButtonVue.vue'

@Component({
  components: { BaseButtonVue },
})
export default class TextButtonView extends Vue {
  @Prop({ required: true })
  readonly condition: Condition

  onClick(condition: Condition) {
    this.$emit('click', condition)
  }
}
